import React from 'react';

const Phone = () => (
  <div>
    <br /><br />
    <h2>Phone Service Information</h2>
    <p>Plan information coming soon</p>
  </div>
);

export default Phone;


// WEBPACK FOOTER //
// ./src/components/sections/services/phone.js